export const usersList = {
  WAFFY_USERS: "مستخدمي وفّي",
  USERS: "العملاء",
  USERS_LIST: "قائمة المستخدمين",
  FIND_A_USER: "… اﺑﺤﺚ ﻋﻦ مستخدم",
  USER_HEADING: "ادراة العملاء",
  CUSTOMER_NAME: "إسم العميل",
  MOBILE_NUMBER: "رقم الجوال",
  PREACH: "أبشر",
  DOCUMENTATION: "التوثيق",
  THE_CONDITION: "الحالة",
  DATE_CREATED: "تاريخ الإنشاء",
  SUSPENDED: "معطل",
  ACTIVE: "نشط",
  TABLE_TTITLE_NAME: "   اسم العميل ",
  TABLE_TTITLE_NUMBER: "  رقم المحمول ",
  TABLE_TTITLE_ABSHER: " أبشر ",
  TABLE_TTITLE_STATUS: " الحالة ",
  TABLE_TTITLE_ACTIONS_ACTIVE: " تفعيل الحساب",
  TABLE_TTITLE_ACTIONS_DEACTIVE: " تعطيل الحساب",
  TABLE_ACTIVE: " مفعل ",
  TABLE_DEACTIVE: " معطل",
  SEARCH_DESC: "البحث عن طريق الاسم او رقم الجوال",
  MAKE_USER_BROKER: "اجعل المستخدم ضامن",
  CONFIRM_CHANGE_TO_BROKER: "هل أنت متأكد من تحويل هذا المستخدم إلي ضامن؟",
};

export enum ALERT {
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
  NONE = "NONE",
}

export enum USER_TYPE {
  BROKER = "BROKER",
  COMPLEX_CREATOR = "COMPLEX_CREATOR",
}
